import React, { useEffect, useRef, useState } from "react";
import "./styles.css";
import { Breadcrumb, PopUpModal, TextInput, Title } from "../../Components/Atoms";
import { Button, useToast } from "@chakra-ui/react";
import { mapDeviceToVehicle, updateVehicleDetail, verifyVehicleDetails } from "../../APIs";
import { CircledCheckIcon, TickIcon } from "../../Assets/images/svgs";
import { useLocation, useNavigate } from "react-router-dom";
import PATHS from "../../Routes/paths";
import { PING_TEST_STEPS, UNSET_REASON_KEY } from "../../Library/constants";
import PingTest from "../SpecificDevice/PingTest";


const MapToVehicle = () => {
  const Toast = useToast();
  const location = useLocation();
  const searchParams = new URLSearchParams(window.location.search);
  const imei = searchParams.get("imei");
  const idx = searchParams.get("idx");
  const isEdit = searchParams.get("edit");
  const instock = searchParams.get("inStock");
  const installed = searchParams.get("installed");
  const liveTracking = useRef(searchParams.get("liveTracking") === "true");
  const isChassisImgUploaded = location.state?.chassisImg ? true : false;

  const initialState = {
    chassisNo: location.state?.chNum || "",
    registrationNo: location.state?.reg || "",
  };
  const [formData, setFormData] = useState(initialState);
  const [formErrors, setFormErrors] = useState({});
  const [isDisabled, setIsDisabled] = useState(true);
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const [selectedImage, setSelectedImage] = useState(null);
  const fileInputRef = useRef(null);
  const [ pingTestProps, setPingTestProps ] = useState({});

  const navigate = useNavigate();

  const paths = [
    { idx: 0, name: "Inventory Management", link: PATHS.INVENTORY_OVERVIEW },
    { idx: 1, name: "Map Device", link: "", isCurrentPage: true },
  ];

  const getNavLink = () => {
    let url = `${PATHS.SHOW_DEALERS}/${PATHS.SPECIFIC_DEVICE}?imei=${imei}&idx=${idx}&isDm=true`;
    if (instock) url += `&inStock=true`;
    if (installed) url += `&installed=true`;
    return url;
  }
  const editPaths = [
    { idx: 0, name: "Device & Vehicle Details ", link: getNavLink() },
    { idx: 1, name: "Edit Vehicle Details", isCurrentPage: true },
  ]

  const liveTrackingEditPaths = [
    { idx: 0, name: "Live Tracking", link: PATHS.LIVE_TRACKING },
    { idx: 1, name: "Device Details", link: `${PATHS.LIVE_TRACKING}/${PATHS.SPECIFIC_DEVICE}?imei=${imei}&idx=${idx}&lt=true&showButtons=true&liveTracking=true` },
    { idx: 1, name: "Edit Vehicle Details", isCurrentPage: true },
  ];

  const setFormFieldData = (key) => (value) => {
    setFormErrors({ [key]: "" });
    setFormData((prev) => ({ ...prev, [key]: value }));
  };

  const VerifyDetails = async (data) => {
    try {
      await verifyVehicleDetails(data);
      return true;
    }
    catch (error) {
      Toast({ isClosable: true, description: error, position: "bottom", variant: "subtle", duration: 3000 });
      return false;
    }
  }

  const handleMapDevice = async () => {
    const errors = {};
    if (!formData.chassisNo) return;

    if (errors.chassisNo) return setFormErrors(errors);

    if (formData.chassisNo === imei) {
      return setFormErrors({ generalError: "Device IMEI and Chassis No cannot be same" });
    }

    let vehicle = { imei: imei, chNum: formData.chassisNo };
    if(formData.registrationNo){
      vehicle.reg = formData.registrationNo;
    }

    const isVerified = await VerifyDetails(vehicle);
    if (!isVerified) return;

    mapDeviceToVehicle({ vehicles: [vehicle] }, selectedImage ? [selectedImage] : [], (err) => {
      if (err) {
        console.error(err);
        setFormErrors({ generalError: "Error Mapping Device to Vehicle, Please try again" });
      }
      else {
        window.localStorage.removeItem(UNSET_REASON_KEY);
        setShowSuccessModal(true);
        setTimeout(() => {
          navigate(`${PATHS.INVENTORY_OVERVIEW}/${PATHS.SPECIFIC_DEVICE}?imei=${imei}`);
        }, 2000)
      }
    });
  };

  const handleUpdateVehicleDetails = async () => {
    let data = {
      vid: location.state.vid,
    }

    if (formData.chassisNo !== location.state.chNum) {
      data.chNum = formData.chassisNo;
    }

    if ((formData.registrationNo) && (formData.registrationNo !== location.state.reg)) {
      data.reg = formData.registrationNo;
    }

    if (formData.chassisNo === imei) {
      return setFormErrors({ generalError: "Device IMEI and Chassis No cannot be same" });
    }

    if (Object.keys(data).length === 1 && !selectedImage) {
      Toast({
        isClosable: true,
        description: "No Changes made to save !!",
        position: "bottom",
        variant: "subtle",
        duration: 3000,
      });
      return;
    }

    if (data.chNum || data.reg) {
      const isVerified = await VerifyDetails(data);
      if (!isVerified) return;
    }

    updateVehicleDetail(data, selectedImage ? [selectedImage] : [], (err) => {
      if (err) {
        console.error("Error Updating Vehicle Details", err);
        setFormErrors({ generalError: "Error Updating Vehicle Details, Please try again" });
      }
      else {
        setShowSuccessModal(true);
        setTimeout(() => {
          navigate(getNavLink());
        }, 2000)
      }
    })
  }

  useEffect(() => {
    setIsDisabled(formData.chassisNo ? false : true);
  }, [formData]);

  const handleWirelessTestingSuccess = (data) => {
    if (data.externalVolt === 0 || data.voltLvl === 0) setPingTestProps({show: true, currentStep: PING_TEST_STEPS.IGN_DETECTED, lowVoltage: true, hideClose: true});
  }

  const onWsConnected = () => {
    if (global.WS) global.WS.sendRequest({ action: global.EE.EVENT_TYPES.SUBSCRIBE_FOR_WIRELESS_TESTING, data: { imei: imei, d: 'onWsConnected' } });
  }

  useEffect(() => {
    global.EE.addEventListener(global.EE.EVENT_TYPES.WS_CONNECTED, onWsConnected);
    global.EE.addEventListener(global.EE.EVENT_TYPES.WIRELESS_TESTING_SUCCESSFULL, handleWirelessTestingSuccess);

    return () => {
      global.EE.removeEventListener(global.EE.EVENT_TYPES.WIRELESS_TESTING_SUCCESSFULL, handleWirelessTestingSuccess);
    }
  }, []);

  const handleRestartRetry = () => {
    navigate(`${PATHS.INVENTORY_OVERVIEW}/${PATHS.SPECIFIC_DEVICE}?imei=${imei}`);
  }

  const getSuccessModalBody = () => {
    return (
      <div>
        <div className="device-mapped-success">
          <CircledCheckIcon />
          <p>{ isEdit ? "Vehicle Details Updated Successfully" : "Device Mapped to Vehicle Successfully" }</p>
        </div>
      </div>
    )
  }

  const handleFileUpload = (e) => {
    if (e.target.files.length > 0) setSelectedImage(e.target.files[0]);
  }

  return (
    <div className="map-device">
      <div className="breadcrumb-container">
        <Breadcrumb paths={liveTracking.current ? liveTrackingEditPaths : isEdit ? editPaths : paths} />
      </div>

      <div className="map-device-content">
        <div className="title-container">
          <Title>{ isEdit ? "Edit Vehicle Details" : "Map Device to Vehicle" }</Title>
        </div>

        <div className="device-imei">
          <p>
            <span className="key">Device IMEI:</span>
            <span className="value">{imei}</span>
          </p>
        </div>

        <div className="map-device-form">
          <div className="form-head">
            <h3>Vehicle Details</h3>
            <hr />
          </div>
          <div className="form-fields">
            <TextInput
              inputName="chassisNo"
              placeholder="Enter Chassis Number"
              className="chassis-no"
              label="Chassis No"
              labelClassName="chassis-no-label"
              errMessage={formErrors.chassisNo || ""}
              onChange={setFormFieldData("chassisNo")}
              value={formData.chassisNo}
              isRequired={true}
              disabled={false}
            />

            <div className="upload-image-field">
              <p onClick={() => fileInputRef.current.click()} className="upload-image-btn">
                {selectedImage || isChassisImgUploaded ? "Change Chassis Number Image" : "Upload Chassis Number Image"} {selectedImage  && <TickIcon />}
              </p>

              <input
                type="file"
                accept="image/*"
                style={{ display: 'none' }}
                ref={fileInputRef}
                onChange={handleFileUpload}
                name="image"
              />
            </div>

            <TextInput
              inputName="registrationNo"
              placeholder="Enter Registration Number"
              className="internal-id"
              label="Registration Number"
              labelClassName="internal-id-label"
              errMessage={formErrors.registrationNo || ""}
              onChange={setFormFieldData("registrationNo")}
              value={formData.registrationNo}
              isRequired={false}
              disabled={false}
            />
          </div>
          <div className="err-cnt">
            <span className="err-text">
              {formErrors.generalError || ""}
            </span>
          </div>
        </div>
      </div>

      <div className="button-container">
        <Button
          className={isDisabled === true ? "disabled-btn" : "map-btn"}
          onClick={isEdit ? handleUpdateVehicleDetails : handleMapDevice}
        >
          { isEdit ? "Update Vehicle Details" : "Map Device" }
        </Button>
      </div>

      <PopUpModal open={showSuccessModal} modalMsg={getSuccessModalBody()} onModalClose={() => {}} darken />
      <PingTest {...pingTestProps} handleRestartRetry={handleRestartRetry} />
    </div>
  );
};

export default MapToVehicle;
